import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { fetchPageBySlug } from "../services/wpPagesApi";

export function useWordPressPage(slug, { lang: langOverride } = {}) {
  const { i18n } = useTranslation();
  const lang = langOverride || i18n.language;
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(Boolean(slug));
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!slug) {
      setPage(null);
      setLoading(false);
      setError(null);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    fetchPageBySlug(slug, { lang })
      .then((result) => {
        if (!cancelled) {
          setPage(result);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err);
          setPage(null);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [slug, lang]);

  return { page, loading, error };
}
